import React from 'react';

import './SavedChecklists.scss';
import { link } from '../../helpers/link';
import BackButton from '../BackButton/BackButton.jsx';

export default function SavedChecklists(props) {
  return (
    <section id="savedCheckLists">
      <BackButton />

      <ul>
        {props.list.map((item) => (
          <li className="savedCheckLists_item" key={item.id}>
            <div className="savedCheckLists_item_image">
              <img alt="item-image" src="/dashboardCategories/checklists.png" />

              <p className="savedCheckLists_item_category">{item.name}</p>
            </div>

            <div className="savedCheckLists_item_description">
              <div>
                <div>
                  <p>{item.name}</p>
                </div>

                <span onClick={() => removeChecklist(item.id)}>&times;</span>
              </div>

              <div className="savedCheckLists_item_button">
                {link(
                  <button>Bekijken</button>,
                  `/saved-checklists?id=${item.id}`
                )}
              </div>
            </div>
          </li>
        ))}
      </ul>

      <button
        className="savedCheckLists-button"
        onClick={() => removeAllChecklists()}
      >
        Alle checklists verwijderen
      </button>
    </section>
  );

  function removeChecklist(id) {
    props.savedChecklistItems.forEach((item) => {
      if (item.list.id !== id) return;

      props.setUserListItem({ variables: { listItemId: +item.id } });
    });
  }

  function removeAllChecklists() {
    props.savedChecklistItems.forEach((item) =>
      props.setUserListItem({ variables: { listItemId: +item.id } })
    );
  }
}
